import React from 'react';
import PropTypes from 'prop-types';

import { translate } from 'react-i18next';

import Checkbox from '../../Input/Checkbox';

export class PolarClubCommunication extends React.Component {
    static displayName = 'Module.UserSettings.PolarClubCommunication';     
    static propTypes = {
        t: PropTypes.func
    };

    constructor(props) {
        super(props);
    }

    render() {
        const { t } = this.props;
        return (
            <div className="row">
                <div className="control-group col-md-12 ">
                    <div className="col-md-3 label-wrapper">
                        <div className="left-label">
                            {t('ffc:session_summary_email.polar_club_communication.title')}
                        </div>
                    </div>
                    <div className="controls col-md-7">
                        <Checkbox onChange={(event) => this.props.onChange(event.state.checked)}
                            checked={this.props.value}
                            key={Math.random()}
                            id="club_communication_checkbox"/>
                        <span className="info_text">
                            {t('ffc:session_summary_email.polar_club_communication.text')}
                        </span>
                        <p className="help-block" />
                    </div>
                </div>
            </div>
        );
    }
}

PolarClubCommunication.propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func
};

export default translate('ffc', { wait: true })(PolarClubCommunication);


// WEBPACK FOOTER //
// ./src/UserSettings/components/PrivacyView/PolarClubCommunication/index.jsx